<section class="hero flex">
  <img src="assets/hero.jpg" alt="" class="object-cover">
</section>